import React, { useEffect, useState, useMemo, useRef } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import "../App.css";
import '../assets/css/gapsybdmupload.css';
import '../assets/css/Tableproperty.css';
import { Button, FormCheck, Dropdown, DropdownButton } from 'react-bootstrap';
import autoTable from 'jspdf-autotable';
import Papa from 'papaparse'; // Import papaparse
import ExcelJS from 'exceljs';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import axios from 'axios';
import { jsPDF } from "jspdf";
import 'bootstrap/dist/css/bootstrap.min.css';
// import { Modal, Button, Form, Dropdown, OverlayTrigger, Tooltip } from 'react-bootstrap';
import { UploadLoadingIcon } from "../components/Propertyfile";
import { Audittemplatelist, AllTemplateColumns, GenerateAuditReport, PortURL } from '../components/ApiProperty';
import Header from './gapsy-header';
import Navigation from './gapsy-Cnavigation';
import Footer from './gapsy-footer';
import "bootstrap/dist/css/bootstrap.min.css"
import 'bootstrap-icons/font/bootstrap-icons.css';
import styles from '../assets/css/gapsy-dashboard.module.css';
import DepartmentDropdown from "../components/Dropdown"; // Adjust path based on file location
import { faSort, faSortUp, faSortDown, faListAlt, faFilter } from '@fortawesome/free-solid-svg-icons';
import '../assets/css/gapsycaudit.css';
import tableStyles from '../assets/css/sharedTableStyles.module.css';
import tabStyles from '../assets/css/gapsy-tabs.module.css';

const GapsyCaudit = () => {
  const navigate = useNavigate();
  const [activeTab, setActiveTab] = useState('outline'); // 'manual' or 'ai'
  const [filteredTables, setFilteredTables] = useState([]);
  const [selectedPrefix, setSelectedPrefix] = useState("");
  const [loading, setLoading] = useState(false);
  const [selectedTable, setSelectedTable] = useState(null);
  const [tableNames, setTableNames] = useState([]);
  const [currentPage1, setCurrentPage1] = useState(1);
  const [recordsPerPage1] = useState(7); // Set the number of records per page
  const [selectedName, setSelectedName] = useState('');
  const [searchQuery, setSearchQuery] = useState('');
  const prefixes = Object.keys(tableNames);
  const [sheetSelectionModal, setSheetSelectionModal] = useState({
    show: false,
    sheets: [],
    selectedSheets: [],
    workbook: null,
    file: null,
  });
  const [columns, setColumns] = useState([]);
  const [selectedColumns, setSelectedColumns] = useState([]);
  const [sumColumns, setSumColumns] = useState([]);
  const [fromDate, setFromDate] = useState("");
  const [toDate, setToDate] = useState("");
  const [availableSumColumns, setAvailableSumColumns] = useState([]);
  const [fileName, setFileName] = useState('');
  const [tableData, setTableData] = useState([]);
  const [tableColumns, setTableColumns] = useState([]);
  const [originalResponseData, setOriginalResponseData] = useState([]);
  const [error, setError] = useState("");
  const [sums, setSums] = useState({});
  const [filteredData, setFilteredData] = useState([]);
  const username = localStorage.getItem('username');
  const userRole = localStorage.getItem('userRole');
  const [sortConfig, setSortConfig] = useState({ key: '', direction: 'asc' });
  const [tempSelectedTable, setTempSelectedTable] = useState('');

  const department = sessionStorage.getItem("dept");
  let csrfToken = sessionStorage.getItem("tokenizedSession");

  useEffect(() => {
    fetchData();
  }, []);

  useEffect(() => {
    const computedSums = calculateSums();
    setSums(computedSums);
  }, [tableData, sumColumns, searchQuery, fromDate, toDate]);

  const userId = localStorage.getItem("userid");

  const fetchData = async () => {
    try {

      const config = {
        params: { checkerId: userId, dept: department },
        headers: {
          'x-csrf-token': csrfToken,
        },
        withCredentials: true
      };

      const response = await axios.post(Audittemplatelist, {}, config);


      const message = "Nothing pending for Upload data";

      if (response.data?.tableList?.length) {
        // Categorize tables by prefix
        const categorizedTables = {};

        response.data.tableList.forEach((table) => {
          const [prefix, ...rest] = table.split('_');
          if (!categorizedTables[prefix]) {
            categorizedTables[prefix] = [];
          }
          categorizedTables[prefix].push(table);
        });

        setTableNames(categorizedTables);
      } else {
        // responseBKP(response, setTableNames, message);
      }
    } catch (error) {
      console.error('Error fetching data:', error);
    }
  };

  useEffect(() => {
    if (selectedPrefix) {
      // Set the filtered tables based on selectedPrefix
      setFilteredTables(tableNames[selectedPrefix] || []);
    } else {
      setFilteredTables([]); // Clear when no prefix is selected
    }
  }, [selectedPrefix, tableNames]);


  const formatDate = (dateString) => {
    const date = new Date(dateString);
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    return `${year}-${month}-${day}`;
  };


  const paginate1 = (pageNumber) => {
    setCurrentPage1(pageNumber);
  };


  const toTitleCase = (str) => {
    return str
      .replace(/[_-]/g, ' ')
      .replace(/([a-z])([A-Z])/g, '$1 $2')
      .replace(/\w\S*/g, (w) => w.charAt(0).toUpperCase() + w.slice(1).toLowerCase());
  };

  const handleselecttable = async (tempSelectedTable) => {
    try {
      const config = {
        headers: {
          'userId': localStorage.getItem('userid'), 'x-csrf-token': csrfToken,
        },
        withCredentials: true,
        params: { tableName: tempSelectedTable }
      };

      const response = await axios.post(AllTemplateColumns, {}, config);
      return response.data?.col_name || [];
    } catch (error) {
      console.error('Error fetching columns:', error);
      return [];
    }
  };


  const filteredRecords1 = useMemo(() => {
    if (!selectedPrefix) return [];

    const query = searchQuery.toLowerCase().trim();
    const filteredTablesForPrefix = tableNames[selectedPrefix] || [];

    return filteredTablesForPrefix.filter((tableName) =>
      tableName.toLowerCase().includes(query)
    );
  }, [tableNames, searchQuery, selectedPrefix]);

  useEffect(() => {
    setCurrentPage1(1);
  }, [searchQuery]);

  useEffect(() => {
    setCurrentPage1(1);
  }, [selectedPrefix]);

  const sortedRecords1 = useMemo(() => {
    return [...filteredRecords1].sort((a, b) => {
      const aStarts = a.toLowerCase().startsWith(searchQuery.toLowerCase());
      const bStarts = b.toLowerCase().startsWith(searchQuery.toLowerCase());
      return bStarts - aStarts;
    });
  }, [filteredRecords1, searchQuery]);

  const indexOfLastRecord = currentPage1 * recordsPerPage1;
  const indexOfFirstRecord = indexOfLastRecord - recordsPerPage1;
  const currentRecords1 = sortedRecords1.slice(indexOfFirstRecord, indexOfLastRecord);

  const totalPages1 = Math.ceil(sortedRecords1.length / recordsPerPage1);



  const columnOrderMap = {
    reporting_date: 'Reporting Date',
    borrower_name: 'Borrower Name',
    customer_number: 'Customer Number',
    account_number: 'Account Number',
    asset_classification: 'Asset Classification',
    npa_amount: 'Npa Amount',
    specificprovision_amount: 'Specificprovision Amount'
  };


  const handleTableChange = (e) => {
    const selectedFullName = e.target.value;

    setTempSelectedTable(selectedFullName);

    const prefix = selectedFullName.split('_')[0];
    const suffix = selectedFullName.split('_').slice(1).join('_');

    setSelectedPrefix(prefix);
    setSelectedName(suffix); // Just store for future

    setColumns([]);
    setSelectedColumns([]);
    setTableColumns([]);
    setTableData([]);
    setOriginalResponseData([]);
  };



  
  const isAllSelected = (columns, tempSelectedColumns) =>
    columns.length > 0 && columns.every((col) => tempSelectedColumns.includes(col));

  const isPartiallySelected = (columns, tempSelectedColumns) =>
    columns.some((col) => tempSelectedColumns.includes(col)) &&
    !isAllSelected(columns, tempSelectedColumns);

  

  const auditColumnOrder = [
    'Submitted_Date', 'Submitted_By',
    'Modified_Date', 'Modified_By',
    'Rejected_Date', 'Rejected_By',
    'Approved_Date', 'Approved_By'
  ];

  const generateReport = async () => {
    setLoading(true);
    const startTime = Date.now(); // start time

    const selectedCols = selectedColumns;
    setSelectedColumns(selectedCols);
    setSelectedTable(tempSelectedTable);

    const tableName = tempSelectedTable + '_history';
    try {
      const config = {
        params: {
          tableName: tableName,
          columns: selectedCols.join(",")
        },
        headers: {
          'x-csrf-token': csrfToken,
        },
        withCredentials: true
      };

      const res = await axios.post(GenerateAuditReport, {}, config);
      const jsonData = Array.isArray(res.data) ? res.data : [];

      // Your transformation logic
      const finalColumns = selectedCols.map(col => toTitleCase(col));
      const transformedData = jsonData.map(row => {
        const newRow = {};
        selectedCols.forEach(col => {
          if (row.hasOwnProperty(col)) {
            newRow[toTitleCase(col)] = row[col];
          }
        });

        auditColumnOrder.forEach(auditCol => {
          if (row[auditCol] !== undefined) {
            const label = toTitleCase(auditCol.replace(/_/g, ' '));
            newRow[label] = row[auditCol];
            if (!finalColumns.includes(label)) {
              finalColumns.push(label);
            }
          }
        });

        return newRow;
      });

      setTableColumns(finalColumns);
      setTableData(transformedData);
      setOriginalResponseData(jsonData);
    } catch (error) {
      console.error("Error:", error);
      setError(error.message);
    } finally {
      // const elapsed = Date.now() - startTime;
      // const delay = 1000 - elapsed;
      // if (delay > 0) {
      //   setTimeout(() => setLoading(false), delay);
      // } else {
      //   setLoading(false);
      // }
      setLoading(false);
    }
  };




  const calculateSums = () => {
    const sums = {};

    // Convert fromDate and toDate strings to Date objects and only keep the date part
    const fromDateObj = fromDate ? new Date(fromDate) : null;
    const toDateObj = toDate ? new Date(toDate) : null;

    if (fromDateObj) {
      fromDateObj.setHours(0, 0, 0, 0); // Start of the day
    }
    if (toDateObj) {
      toDateObj.setHours(23, 59, 59, 999); // End of the day
    }

    // Filter the table data based on the search query and date range
    const filteredData = tableData.filter(row => {
      // Filter by search query
      const matchesSearchQuery = !searchQuery || Object.values(row).some(value =>
        // value.toString().toLowerCase().includes(searchQuery.toLowerCase())
        value != null && value.toString().toLowerCase().includes(searchQuery.toLowerCase())
      );

      // Function to convert a string to Proper Case (PropCase)
      function toProperCase(str) {
        return str.charAt(0).toUpperCase() + str.slice(1).toLowerCase();
      }
      // Normalize all keys to Proper Case
      const normalizedRow = Object.keys(row).reduce((acc, key) => {
        const properCaseKey = toProperCase(key);
        acc[properCaseKey] = row[key];
        return acc;
      }, {});

      // Try both possible keys for reporting date
      const reportingDateValue = row['reporting_date'] || row['Reporting Date'];
      const reportingDate = reportingDateValue ? new Date(reportingDateValue) : null;

      // Check for invalid date
      if (reportingDate && isNaN(reportingDate.getTime())) {
        console.error(`Invalid date: ${reportingDateValue}`);
        return false;
      }
      // Strip time from reportingDate for comparison
      if (reportingDate) {
        reportingDate.setHours(0, 0, 0, 0);
      }


      // Filter by date range
      const isWithinDateRange = (() => {
        if (fromDateObj && !toDateObj) {
          // Only fromDate is specified
          return reportingDate && reportingDate.getTime() === fromDateObj.getTime();
        }
        if (!fromDateObj && toDateObj) {
          // Only toDate is specified
          return reportingDate && reportingDate.getTime() === toDateObj.getTime();
        }
        if (fromDateObj && toDateObj) {
          // Both fromDate and toDate are specified
          return reportingDate && reportingDate >= fromDateObj && reportingDate <= toDateObj;
        }
        // No date filters are specified
        return true;
      })();

      return matchesSearchQuery && isWithinDateRange;
    });

    // Calculate sums for the selected numeric columns
    sumColumns.forEach((col) => {
      if (availableSumColumns.includes(col)) { // Ensure column is numeric
        const sum = filteredData.reduce((acc, row) => {
          const value = parseFloat(row[col]);
          return !isNaN(value) ? acc + value : acc;
        }, 0);
        sums[col] = sum;
      }
    });

    setFilteredData(filteredData); // Store the filtered data for display
    return sums;
  };

  const downloadXLSX = async () => {
    try {
      // 1. Ensure we have a valid table name
      const tableName = selectedTable ?
        selectedTable.replace(/_/g, ' ').toUpperCase() :
        'Report';

      // 2. Create workbook with validated sheet name
      const workbook = new ExcelJS.Workbook();
      const worksheet = workbook.addWorksheet(
        tableName.substring(0, 31) // Excel sheet name limit
      );

      // 3. Add Report Title at top
      const titleRow = worksheet.addRow([tableName]);
      titleRow.font = {
        size: 14,
        bold: true,
        color: { argb: 'FF366872' } // Your theme color
      };
      titleRow.alignment = { horizontal: 'center' };

      // Merge title cells across all columns
      if (tableColumns.length > 0) {
        worksheet.mergeCells(`A1:${String.fromCharCode(64 + tableColumns.length)}1`);
      }
      // Add spacing row
      worksheet.addRow([]);

      // Add headers with consistent styling
      const headerRow = worksheet.addRow(tableColumns);
      headerRow.font = {
        bold: true,
        color: { argb: 'FFFFFFFF' }, // White text
        size: 10 // Smaller header font
      };
      headerRow.alignment = {
        horizontal: 'center',
        vertical: 'middle',
        wrapText: true
      };
      headerRow.height = 20; // Set header row height

      // Apply header styling to each cell
      headerRow.eachCell((cell) => {
        cell.fill = {
          type: 'pattern',
          pattern: 'solid',
          fgColor: { argb: 'FF366872' } // Your theme color
        };
        cell.border = {
          top: { style: 'thin', color: { argb: 'FF000000' } },
          left: { style: 'thin', color: { argb: 'FF000000' } },
          bottom: { style: 'thin', color: { argb: 'FF000000' } },
          right: { style: 'thin', color: { argb: 'FF000000' } }
        };
      });

      // Add data rows with status column coloring
      filteredData.forEach((row, rowIndex) => {
        const dataRow = worksheet.addRow(tableColumns.map(col => {
          const cellValue = row[col];
          return (cellValue === '\N' || cellValue === '\\N' || cellValue === 'NULL') ? '' : cellValue;
        }));

        // Apply styling to each cell
        dataRow.eachCell((cell, colNumber) => {
          const columnName = tableColumns[colNumber - 1];

          // Base cell styling
          cell.alignment = {
            horizontal: 'center',
            vertical: 'middle',
            wrapText: true
          };
          cell.border = {
            top: { style: 'thin', color: { argb: 'FF000000' } },
            left: { style: 'thin', color: { argb: 'FF000000' } },
            bottom: { style: 'thin', color: { argb: 'FF000000' } },
            right: { style: 'thin', color: { argb: 'FF000000' } }
          };
          cell.font = {
            size: 9 // Smaller body font
          };

          // Status column coloring (matches PDF)
          if (columnName === 'Submitted Date' || columnName === 'Submitted By') {
            cell.fill = {
              type: 'pattern',
              pattern: 'solid',
              fgColor: { argb: 'FFE6F7FF' } // Light blue
            };
            cell.font = {
              color: { argb: 'FF0056B3' }, // Dark blue text
              size: 9
            };
          } else if (columnName === 'Rejected Date' || columnName === 'Rejected By') {
            cell.fill = {
              type: 'pattern',
              pattern: 'solid',
              fgColor: { argb: 'FFFFEBEE' } // Light red
            };
            cell.font = {
              color: { argb: 'FFC62828' }, // Dark red text
              size: 9
            };
          } else if (columnName === 'Modified Date' || columnName === 'Modified By') {
            cell.fill = {
              type: 'pattern',
              pattern: 'solid',
              fgColor: { argb: 'FFFFF3E0' } // Light orange
            };
            cell.font = {
              color: { argb: 'FFE65100' }, // Dark orange text
              size: 9
            };
          } else if (columnName === 'Approved Date' || columnName === 'Approved By') {
            cell.fill = {
              type: 'pattern',
              pattern: 'solid',
              fgColor: { argb: 'FFE8F5E9' } // Light green
            };
            cell.font = {
              color: { argb: 'FF2E7D32' }, // Dark green text
              size: 9
            };
          } else if (rowIndex % 2 === 1) {
            // Alternate row coloring
            cell.fill = {
              type: 'pattern',
              pattern: 'solid',
              fgColor: { argb: 'FFF9F9F9' } // Light gray
            };
          }
        });
      });

      // Add sum row if needed
      if (sumColumns.length > 0) {
        const sumRow = tableColumns.map(col => (
          sumColumns.includes(col) && sums[col] !== undefined ? `Total: ${sums[col]}` : ""
        ));
        const sumRowAdded = worksheet.addRow(sumRow);
        sumRowAdded.font = { bold: true };
        sumRowAdded.eachCell(cell => {
          cell.border = {
            top: { style: 'thin', color: { argb: 'FF000000' } },
            left: { style: 'thin', color: { argb: 'FF000000' } },
            bottom: { style: 'thin', color: { argb: 'FF000000' } },
            right: { style: 'thin', color: { argb: 'FF000000' } }
          };
        });
      }

      // Add footer information
      worksheet.addRow([]); // Spacer row

      const footerRow = worksheet.addRow(Array(tableColumns.length).fill(''));
      footerRow.getCell(1).value = `Prepared By: ${username}, ${userRole}`;
      footerRow.getCell(tableColumns.length).value =
        `Date: ${new Date().toLocaleDateString()} ${new Date().toLocaleTimeString()}`;

      // Style footer
      footerRow.getCell(1).font = {
        size: 8,
        italic: true,
        color: { argb: 'FF366872' } // Theme color
      };
      footerRow.getCell(tableColumns.length).font = {
        size: 8,
        italic: true,
        color: { argb: 'FF366872' } // Theme color
      };
      footerRow.getCell(1).alignment = { horizontal: 'left' };
      footerRow.getCell(tableColumns.length).alignment = { horizontal: 'right' };

      // Auto-size columns with limits
      worksheet.columns.forEach(column => {
        let maxLength = 0;
        column.eachCell({ includeEmpty: true }, cell => {
          const columnLength = cell.value ? cell.value.toString().length : 0;
          maxLength = Math.max(maxLength, columnLength);
        });
        column.width = Math.min(Math.max(maxLength + 2, 10), 30); // Min 10, Max 30
      });

      // Freeze header row
      worksheet.views = [
        { state: 'frozen', xSplit: 0, ySplit: 2 } // Freeze title and header rows
      ];

      // 4. Generate filename with table name first
      const date = new Date();
      const formattedDate = date.toISOString().slice(0, 10).replace(/-/g, '-'); // YYYY-MM-DD

      // Ensure table name is in filename before date
      const fileName = `${tableName.replace(/\s+/g, '_')}_${formattedDate}.xlsx`;

      // 5. Save the workbook
      const buffer = await workbook.xlsx.writeBuffer();
      const blob = new Blob([buffer], {
        type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
      });

      const link = document.createElement('a');
      link.href = URL.createObjectURL(blob);
      link.download = fileName;
      document.body.appendChild(link);
      link.click();
      setTimeout(() => {
        document.body.removeChild(link);
        URL.revokeObjectURL(link.href);
      }, 100);

    } catch (error) {
      console.error('Error generating XLSX:', error);
      alert('Error generating Excel file. Please try again.');
    }
  };

  const downloadPDF = () => {
    // Create PDF with custom width to fit all columns
    const doc = new jsPDF({
      orientation: 'landscape',
      unit: 'mm',
      format: [500, 210] // Very wide page (500mm) to fit all columns
    });

    // Set smaller font sizes
    const headerFontSize = 10; // Reduced from 12
    const bodyFontSize = 8;   // Reduced from 10

    // Set table title styling with smaller font
    doc.setFontSize(10); // Smaller title font
    doc.setTextColor(54, 104, 114); // #366872
    doc.setFont('helvetica', 'bold');

    // Add table title (centered)
    const tableTitle = selectedTable
      ? selectedTable.replace(/_/g, ' ').replace(/\b\w/g, char => char.toUpperCase())
      : 'Report';
    const pageWidth = doc.internal.pageSize.getWidth();
    const textWidth = doc.getTextWidth(tableTitle);
    doc.text(tableTitle, (pageWidth - textWidth) / 2, 10); // Moved up slightly

    // Prepare data for the table
    const pdfData = sortedData.map(row =>
      tableColumns.map(col => {
        const cellValue = row[col];
        return (cellValue === '\N' || cellValue === '\\N' || cellValue === 'NULL') ? '' : cellValue;
      })
    );

    // Column styles with reduced padding
    const columnStyles = {};
    tableColumns.forEach((col, index) => {
      columnStyles[index] = {
        cellWidth: 'auto', // Let autoTable calculate width
        minCellWidth: 15,  // Minimum width
        fontSize: bodyFontSize
      };

      // Status column colors
      if (col === 'Submitted Date' || col === 'Submitted By') {
        columnStyles[index].fillColor = [230, 247, 255];
        columnStyles[index].textColor = [0, 86, 179];
      } else if (col === 'Rejected Date' || col === 'Rejected By') {
        columnStyles[index].fillColor = [255, 235, 238];
        columnStyles[index].textColor = [198, 40, 40];
      } else if (col === 'Modified Date' || col === 'Modified By') {
        columnStyles[index].fillColor = [255, 243, 224];
        columnStyles[index].textColor = [230, 81, 0];
      } else if (col === 'Approved Date' || col === 'Approved By') {
        columnStyles[index].fillColor = [232, 245, 233];
        columnStyles[index].textColor = [46, 125, 50];
      }
    });

    // AutoTable configuration for compact display
    autoTable(doc, {
      head: [tableColumns],
      body: pdfData,
      startY: 15, // Start lower to accommodate title
      theme: 'grid',
      tableWidth: 'wrap',
      headStyles: {
        fillColor: [54, 104, 114],
        textColor: [255, 255, 255],
        fontStyle: 'bold',
        fontSize: headerFontSize, // Smaller header font
        halign: 'center',
        cellPadding: 2 // Reduced padding
      },
      bodyStyles: {
        fontSize: bodyFontSize, // Smaller body font
        cellPadding: 1,         // Reduced padding
        overflow: 'linebreak',
        halign: 'center',
        valign: 'middle'
      },
      columnStyles: columnStyles,
      margin: { top: 5, left: 5, right: 5 }, // Reduced margins
      showHead: 'firstPage',
      horizontalPageBreak: false, // Disable horizontal pagination
      pageBreak: 'avoid',         // Try to keep on one page
      styles: {
        fontSize: bodyFontSize,   // Base font size
        cellPadding: 1,          // Compact cells
        overflow: 'linebreak'    // Handle long text
      },
      didDrawPage: function (data) {
        // Compact footer
        doc.setFontSize(6); // Very small footer font
        doc.setTextColor(100);
        const finalY = doc.lastAutoTable.finalY || doc.internal.pageSize.getHeight() - 10;
        doc.text(`Prepared By: ${username}, ${userRole}`, 10, finalY + 5);
        const dateStr = new Date().toLocaleString();
        doc.text(dateStr, pageWidth - doc.getTextWidth(dateStr) - 10, finalY + 5);
      }
    });

    // Generate filename
    const filename = `${selectedTable || 'Report'}_${new Date().toISOString().slice(0, 10)}.pdf`;
    doc.save(filename);
  };

  // Handler for download button click
  const handleDownload = (format) => {
    if (format === 'xlsx') {
      downloadXLSX();
    } else if (format === 'pdf') {
      downloadPDF();
    }
  };





  //table sort start
  const requestSort = (key) => {
    let direction = 'asc';
    if (sortConfig.key === key && sortConfig.direction === 'asc') {
      direction = 'desc';
    }
    setSortConfig({ key, direction });
  };

  const getSortIcon = (key) => {
    if (sortConfig.key === key) {
      return sortConfig.direction === 'asc' ? faSortUp : faSortDown;
    }
    return faSort;
  };

  // Sorting the data based on the selected column and direction
  const sortedData = [...filteredData].sort((a, b) => {
    const aValue = a[sortConfig.key];
    const bValue = b[sortConfig.key];

    // Check if this is a date column (you might want to make this more robust)
    const isDateColumn = sortConfig.key.toLowerCase().includes('date');

    if (isDateColumn) {
      // Convert date strings to Date objects for comparison
      const dateA = new Date(aValue);
      const dateB = new Date(bValue);

      return sortConfig.direction === 'asc'
        ? dateA - dateB
        : dateB - dateA;
    }

    // Check if both values are numeric
    const isNumeric = !isNaN(parseFloat(aValue)) && !isNaN(parseFloat(bValue));

    if (isNumeric) {
      // Numeric comparison
      return sortConfig.direction === 'asc'
        ? parseFloat(aValue) - parseFloat(bValue)
        : parseFloat(bValue) - parseFloat(aValue);
    } else {
      // Lexicographic comparison for strings
      if (aValue < bValue) {
        return sortConfig.direction === 'asc' ? -1 : 1;
      }
      if (aValue > bValue) {
        return sortConfig.direction === 'asc' ? 1 : -1;
      }
      return 0;
    }
  });


  const handleDashboard = () => {
    navigate("/gapsyCdashboard");
  };


  return (
    <div className={`d-flex flex-column min-vh-100 ${styles.pageFullBackground}`}>
      <Header />
      <Navigation />
      <div className="top-0 px-4 py-2 text-white">
        <div className="d-flex justify-content-between align-items-center flex-wrap">
          <div>
            <nav aria-label="breadcrumb">
              <ol className="breadcrumb mb-1">
                <li className="breadcrumb-item">
                  <a className={`text-info ${styles.textInfo}`} onClick={handleDashboard} style={{ textDecoration: 'none' }}>
                    <i className="bi bi-house me-2" style={{ cursor: "pointer" }}></i>/
                  </a>
                </li>
                <li className={`breadcrumb-item active ${styles.breadcrumbItem}`} aria-current="page">
                  <i className="bi bi-file-richtext me-2"></i> Audit Report - Track Changes
                </li>
              </ol>
            </nav>
          </div>

        </div>
      </div>
      <main className="flex-grow-1 container-fluid">
        <div className={styles.mainContainer}>
          <div className="container-fluid">
            <div className="row">
              {/* left side Column code */}
              <div className="col-lg-3 col-md-12">
                <div className={`card h-100 ${styles.cardBorder} ${styles.card}`}>
                  <div className="card-body">
                    <form className="w-100">
                      {/* Custom Tab Navigation */}
                      <div className={tabStyles.tabContainer}>
                        <div
                          className={`${tabStyles.tab} ${activeTab === 'outline' ? tabStyles.activeTab : ''}`}
                          onClick={() => {
                            setActiveTab('outline');
                            setSearchQuery('');
                            setFromDate('');
                            setToDate('');
                          }}
                        >
                          <FontAwesomeIcon icon={faListAlt} className="me-1" />
                          Outline
                        </div>
                        <div
                          className={`${tabStyles.tab} ${activeTab === 'filters' ? tabStyles.activeTab : ''}`}
                          onClick={() => {
                            setActiveTab('filters');
                            setSearchQuery('');
                            setFromDate('');
                            setToDate('');
                          }}
                        >
                          <FontAwesomeIcon icon={faFilter} className="me-1" />
                          Filters
                        </div>
                      </div>


                      {/* Tab Content */}
                      {activeTab === 'outline' && (
                        <div className="row mb-2 p-2">
                          {/* Table select dropdown */}
                          <div className="col-12 mb-2">
                            <label htmlFor="department" className="form-label text-black mb-2">
                              Department
                            </label>
                            <div>
                              <DepartmentDropdown
                                selectedPrefix={selectedPrefix}
                                setSelectedPrefix={(prefix) => {
                                  setSelectedPrefix(prefix);          // update selected prefix
                                  setTempSelectedTable('');           // clear selected table
                                  setSelectedColumns([]);             // clear selected columns
                                  setColumns([]);                     // clear available columns
                                  setTableData([]);                   // clear table data
                                  setTableColumns([]);                // clear table column titles
                                }}
                                prefixes={prefixes}
                              />

                            </div>
                          </div>
                          <div className="col-12 mb-2">
                            <label htmlFor="checkerUser" className="form-label text-black mb-2">
                              Table Selection
                            </label>

                            <div className="table-on-homepage-only">
                              <div className="dropdown position-relative">
                                <button
                                  className="btn btn-light btn-sm dropdown-toggle text-truncate d-flex justify-content-between align-items-center"
                                  type="button"
                                  id="tableDropdown"
                                  data-bs-toggle="dropdown"
                                  aria-expanded="false"
                                  style={{
                                    width: '100%',            // Full width
                                    minWidth: '200px',        // Optional: match select width
                                    textAlign: 'left',        // Ensures text starts from left
                                    paddingRight: '1.5rem'    // Space for dropdown arrow
                                  }}
                                  disabled={!selectedPrefix}
                                >
                                  <span className="text-truncate">
                                    {tempSelectedTable
                                      ? toTitleCase(tempSelectedTable.split('_').slice(1).join('_'))
                                      : "Select Table"}
                                  </span>
                                  <i className="ms-auto dropdown-toggle-icon"></i> {/* Optional arrow spacing control */}
                                </button>

                                <ul
                                  className={`dropdown-menu mt-1 w-100 ${styles.dropdownMenu}`}
                                  aria-labelledby="tableDropdown"
                                >
                                  {sortedRecords1.map((tableName, idx) => {
                                    const suffix = tableName.split('_').slice(1).join('_');
                                    const displayName = toTitleCase(suffix);
                                    return (
                                      <li key={idx}>
                                        <a
                                          className={`dropdown-item small ${styles.dropdownItem}`}
                                          href="#"
                                          onClick={(e) => {
                                            e.preventDefault();
                                            handleTableChange({ target: { value: tableName } });
                                          }}
                                        >
                                          {displayName}
                                        </a>
                                      </li>
                                    );
                                  })}
                                </ul>
                              </div>
                            </div>


                          </div>

                          {/* Columns dropdown */}
                          <div className='col-12 mb-2'>
                            <div className="table-on-homepage-only mb-2">
                              <label htmlFor="checkerUser" className="form-label text-black mb-1">
                                Column Selection
                              </label>
                              <div className="dropdown position-relative">
                                <button
                                  className="btn btn-light btn-sm dropdown-toggle text-truncate d-flex justify-content-between align-items-center"
                                  type="button"
                                  id="columnsDropdown"
                                  data-bs-toggle="dropdown"
                                  aria-expanded="false"
                                  style={{
                                    width: '100%',
                                    minWidth: '200px',
                                    textAlign: 'left',
                                    paddingRight: '1.5rem'
                                  }}
                                  disabled={!tempSelectedTable}
                                  onClick={async () => {
                                    if (tempSelectedTable && columns.length === 0) {
                                      const cols = await handleselecttable(tempSelectedTable);

                                      const ordered = Object.keys(columnOrderMap).filter(col => cols.includes(col));
                                      const extra = cols.filter(col => !ordered.includes(col));
                                      const final = [...ordered, ...extra];

                                      setColumns(final);
                                      setAvailableSumColumns(final);
                                    }
                                  }}
                                >
                                  <span className="text-truncate small">
                                    {selectedColumns.length > 0
                                      ? `${selectedColumns.length} Column${selectedColumns.length > 1 ? 's' : ''} Selected`
                                      : "Select Columns"}
                                  </span>

                                  <i className="ms-auto dropdown-toggle-icon"></i>
                                </button>

                                <ul
                                  className={`dropdown-menu mt-1 w-100 ${styles.dropdownMenu}`}
                                  aria-labelledby="columnsDropdown"
                                  style={{
                                    maxHeight: '200px',
                                    overflowY: 'auto',
                                    fontSize: '12px',
                                    paddingBottom: '5px',
                                    paddingTop: '5px'
                                  }}
                                  onClick={(e) => e.stopPropagation()}
                                >

                                  {columns.length === 0 ? (
                                    <li className="dropdown-item disabled">No Columns Found</li>
                                  ) : (
                                    <>
                                      <li className="dropdown-item px-3 py-1">
                                        <div className="form-check">
                                          <input
                                            className="form-check-input"
                                            type="checkbox"
                                            id="selectAllColumns"
                                            checked={selectedColumns.length === columns.length}
                                            onChange={(e) => {
                                              const checked = e.target.checked;
                                              if (checked) {
                                                setSelectedColumns([...columns]);
                                                setTimeout(() => document.body.click(), 100); // close dropdown
                                              } else {
                                                setSelectedColumns([]);
                                              }
                                            }}
                                          />
                                          <label className="form-check-label" htmlFor="selectAllColumns">
                                            Select All Columns
                                          </label>
                                        </div>
                                      </li>

                                      <li><hr className="dropdown-divider" /></li>

                                      {columns.map((col, idx) => (
                                        <li key={idx} className="dropdown-item px-3 py-1 text-truncate" title={col}>
                                          <div className="form-check">
                                            <input
                                              className="form-check-input"
                                              type="checkbox"
                                              id={`col-${idx}`}
                                              checked={selectedColumns.includes(col)}
                                              onChange={(e) => {
                                                const updated = e.target.checked
                                                  ? [...selectedColumns, col]
                                                  : selectedColumns.filter(c => c !== col);
                                                setSelectedColumns(updated);

                                                if (updated.length === columns.length) {
                                                  setTimeout(() => document.body.click(), 100);
                                                }
                                              }}
                                            />
                                            <label className="form-check-label text-truncate" htmlFor={`col-${idx}`}>
                                              {toTitleCase(col)}
                                            </label>
                                          </div>
                                        </li>
                                      ))}
                                    </>
                                  )}
                                </ul>
                              </div>
                            </div>
                          </div>



                          {/* Generate Report button */}
                          <div className="col-12 mb-2">
                            <Button
                              variant="primary"
                              onClick={generateReport}
                              className="btn btn-sm border-0"
                              style={{ backgroundColor: '#366872', color: 'white' }}
                              disabled={selectedColumns.length === 0}
                            >
                              Generate Report
                            </Button>
                          </div>
                        </div>
                      )}

                    

                      {activeTab === 'filters' && (
                        <div className="row mb-2 p-2">
                          {/* From Date */}
                          <div className="col-12 mb-2">
                            <label htmlFor="department" className="form-label text-black mb-2">
                              From Date
                            </label>
                            <input
                              type="date"
                              className="form-control form-control-sm"
                              id="fromDate"
                              value={fromDate}
                              onChange={(e) => {
                                const value = e.target.value;
                                if (value === "") {
                                  setFromDate("");
                                  setFilteredData(tableData);
                                } else {
                                  const formattedDate = formatDate(value);
                                  setFromDate(formattedDate);
                                }
                              }}
                            />
                          </div>

                          {/* To Date */}
                          <div className="col-12 mb-2">
                            <label htmlFor="department" className="form-label text-black mb-2">
                              To Date
                            </label>
                            <input
                              type="date"
                              className="form-control form-control-sm"
                              id="toDate"
                              value={toDate}
                              onChange={(e) => {
                                const value = e.target.value;
                                if (value === "") {
                                  setToDate("");
                                  setFilteredData(tableData);
                                } else {
                                  const formattedDate = formatDate(value);
                                  setToDate(formattedDate);
                                }
                              }}
                            />
                          </div>

                          {/* Search */}
                          <div className="col-12 mb-2">
                            <label htmlFor="department" className="form-label text-black mb-2">
                              Search
                            </label>
                            <input
                              type="text"
                              className="form-control form-control-sm"
                              id="search"
                              value={searchQuery}
                              onChange={(e) => setSearchQuery(e.target.value)}

                            />
                          </div>

                          {/* Download button */}
                          <div className="col-12 mb-3">
                            <DropdownButton
                              id="dropdown-custom-download"
                              title="Download"
                              variant="success"
                              className="w-100"
                              style={{ fontSize: '13px' }}
                            >
                              <Dropdown.Item style={{ fontSize: '12px' }} onClick={() => handleDownload('xlsx')}>XLSX</Dropdown.Item>
                              <Dropdown.Item style={{ fontSize: '12px' }} onClick={() => handleDownload('pdf')}>PDF</Dropdown.Item>
                            </DropdownButton>
                          </div>
                        </div>
                      )}
                    </form>
                  </div>
                </div>
              </div>
              {/* right Column with Table */}
              <div className="col-lg-9 col-md-12">
                <div className={`card h-100 ${styles.cardBorder} ${styles.card}`}>
                  <div className="card-body d-flex flex-column">
                    <div className="mb-1">
                      <h6 className={`pb-1 mb-2 ${styles.borderBottom}`}>
                        Table Name: {selectedName && selectedName.replace(/_/g, ' ').replace(/\b\w/g, char => char.toUpperCase())}
                      </h6>
                    </div>

                    {/* <div className="flex-grow-1" style={{ maxHeight: '60vh', overflowY: 'auto' }}>
                      <div className='custom-table-with-status-colors w-100'> */}
                    <div className="row">
                      <div className="col">


                        <div className="table-on-homepage-only">

                          <div className={`tableWrapper ${tableStyles.tableWrapper}`}>
                            {loading && (
                              <div className="table-loading-overlay d-flex justify-content-center align-items-center">
                                <UploadLoadingIcon />
                              </div>
                            )}
                            <div className="custom-table-with-status-colors w-100 position-relative">
                              <table className={`table table-bordered table-hover text-center ${tableStyles.customScrollTable}`}>
                                <thead className="sticky-header">
                                  <tr>
                                    {tableColumns.map((col, colIndex) => (
                                      <th
                                        key={colIndex}
                                        style={{
                                          textAlign: 'center',
                                          border: '1px solid black',
                                          padding: '5px',
                                          whiteSpace: 'nowrap',
                                          cursor: 'pointer',
                                          minWidth: '100px'
                                        }}
                                        onClick={() => requestSort(col)}
                                      >
                                        <span style={{ display: 'inline-flex', alignItems: 'center' }}>
                                          {col} <FontAwesomeIcon icon={getSortIcon(col)} style={{ marginLeft: '5px' }} />
                                        </span>
                                      </th>
                                    ))}
                                  </tr>
                                </thead>
                                <tbody style={{ border: '1px solid #ddd', fontSize: '12px' }}>
                                  {sortedData.length > 0 ? (
                                    sortedData.map((row, rowIndex) => (
                                      <tr
                                        key={rowIndex}
                                        style={{
                                          border: '1px solid #ddd',
                                          backgroundColor: rowIndex % 2 === 0 ? '#f9f9f9' : '#ffffff'
                                        }}
                                      >
                                        {tableColumns.map((col, colIndex) => {
                                          const getStatusClass = () => {
                                            if (col === 'Submitted Date' || col === 'Submitted By') {
                                              return 'submitted-status';
                                            }
                                            if (col === 'Rejected Date' || col === 'Rejected By') {
                                              return 'rejected-status';
                                            }
                                            if (col === 'Modified Date' || col === 'Modified By') {
                                              return 'modified-status';
                                            }
                                            if (col === 'Approved Date' || col === 'Approved By') {
                                              return 'approved-status';
                                            }
                                            return '';
                                          };

                                          const cellValue = row[col];
                                          const displayValue = (cellValue === '\N' || cellValue === '\\N' || cellValue === 'NULL')
                                            ? ''
                                            : cellValue;

                                          return (
                                            <td
                                              key={colIndex}
                                              className={getStatusClass()}
                                              style={{
                                                border: '1px solid #ddd',
                                                padding: '5px',
                                                fontSize: '12px',
                                                overflow: 'hidden',
                                                textOverflow: 'ellipsis',
                                                whiteSpace: 'nowrap'
                                              }}
                                            >
                                              {displayValue}
                                            </td>
                                          );
                                        })}
                                      </tr>
                                    ))
                                  ) : (
                                    // <tr>
                                    //   <td colSpan={tableColumns.length} className="text-center py-3">
                                    //     No data available
                                    //   </td>
                                    // </tr>
                                    <tr>
                                      <td colSpan={tableColumns.length || 1} className="text-center py-3 text-muted">
                                        {!selectedPrefix
                                          ? "Select a Department"
                                          : !tempSelectedTable
                                            ? "Select a Tablename"
                                            : selectedColumns.length === 0
                                              ? "Select Columns and Proceed Generate Report"
                                              : "No data found for the selected criteria."}
                                      </td>
                                    </tr>

                                  )}
                                </tbody>
                              </table>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                    

                    {tableData.length > 0 && (
                      <div style={{ display: 'flex', justifyContent: 'space-between', width: '100%', marginBottom: '7px' }}>
                        <div className="text-start" style={{ fontSize: '12px' }}>
                          Total Records: {sortedData.length}
                        </div>
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </main >
      <Footer />
    </div >
  );

}

export default GapsyCaudit;
